import PropTypes from "prop-types";
import Card from "../cards/card";

const CustomerCommon = (props) => {
    return (
        <>
            <div className={"common-card-customer"}>
                <div className={"container"}>
                    <div className={"d-flex"}>
                        {props.data.map((item, index) => {
                            return <Card isHeading={true} title={item.title} heading={item.heading} description={""} />
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}
CustomerCommon.defaultProps = {
    data: []
}

CustomerCommon.propTypes = {
    data: PropTypes.array
}
export default CustomerCommon;